import angular from 'angular';
import uiRouter from 'angular-ui-router';
import { HomeServicesConfig } from './home-services.config';
import { HomeServicesComponent } from './home-services.component';
import { CardModule } from '../../core';
import { HomeServicesContentModule } from './content';
import { RelevantContentComponent } from '../../common/directives';

export const HomeServicesStepModule = angular
  .module('app.steps.home-services', [
    uiRouter,
    CardModule.name,
    RelevantContentComponent.name,
    HomeServicesContentModule.name,
  ])
  .config(HomeServicesConfig)
  .component('updHomeServices', HomeServicesComponent);
